<template>
  <div class="wrapper">
    <v2-row noSpace>
      <v2-col noSpace class="h-full flex-1">
        <v-spinner :loading="isDefaultLoading"></v-spinner>
        <div class="h-full flex items-center flex-1" v-show="!isDefaultLoading">
          <v2-login
            :team="slug"
            :teamUid="teamUid"
            :getTeam="loadTeam"
            :login="login"
            :changeTeam="changeTeam"
            :pinRequest="pinRequest"
            :passwordPolicy="passwordPolicy"
            :pwReset="pwReset"
            :isSmView="isSmView"
            @stopLoading="$store.commit('GLOBAL_DEFAULT_LOADING_ENDED')"
          ></v2-login>
        </div>
      </v2-col>
      <v2-col style="width: 497px" class="bg-v2-secondary-500 p-10 text-white" v-if="isDesktopView">
        <v2-icon :data="require('@icon/envivo.io.svg')" fill color="#fff" width="auto" height="20px"></v2-icon>
        <!--Christmas edition-->
        <!--<div class="flex justify-center">-->
        <!--  <img src="@/assets/img/envivo-christmas.png" alt="logo" style="height: 32px; width: auto" />-->
        <!--</div>-->
        <h1 class="heading-1-b text-v2-secondary-300 mt-5 mb-14">
          {{ $t("teaser.text") }}
        </h1>
        <img src="@/assets/img/login-rocket.png" alt="rocket" />
      </v2-col>
    </v2-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import global from "@/mixins/global.js";

export default {
  name: "Login",
  mixins: [global],
  data() {
    return {
      slug: "",
      teamUid: null,
      passwordPolicy: null,
    };
  },
  created() {
    // if route param teamslug -> check if team was already initialized -> if not loadTeam
    this.initTeam();
    this.$eventbus.$on("initTeam", this.initTeam);
  },
  destroyed() {
    this.$eventbus.$off("initTeam");
  },
  methods: {
    ...mapActions([
      "loginAndGetAuthAccount",
      "getTeamBySlug",
      "initGlobalTeamSettings",
      "pinRequest",
      "pwReset",
      "logout",
      "removeCognitoSession",
    ]),
    initTeam() {
      this.$store.commit("GLOBAL_DEFAULT_LOADING_STARTED");
      // check in teams object if team exists & is authenticated, if not load Team
      let isInitialized = false;
      if (this.$route.params.teamSlug) {
        Object.keys(this.teams).forEach((key) => {
          if (
            this.teams[key].team &&
            this.teams[key].team.slug === this.$route.params.teamSlug &&
            this.teams[key].authenticated
          ) {
            isInitialized = true;
          }
        });
      }
      if (this.$route.params.teamSlug && !isInitialized) {
        this.loadTeam(this.$route.params.teamSlug);
      } else {
        this.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
      }
    },
    loadTeam(slug) {
      const vm = this;
      const lowerCaseSlug = slug.toLowerCase();
      let redirected = false;
      Object.keys(this.teams).forEach((key) => {
        if (this.teams[key].team && this.teams[key].team.slug === slug && this.teams[key].authenticated) {
          vm.$router.push("/t/" + key + "/dashboard");
          this.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
          redirected = true;
        }
      });
      if (!redirected) {
        vm.getTeamBySlug({ slug: lowerCaseSlug })
          .then((res) => {
            vm.slug = vm.teams[res.data.data.uid].team.name;
            vm.slug = vm.slug.toLowerCase();
            vm.teamUid = res.data.data.uid;
            vm.$snotify.clear();
            if (this.$route.name === "PwExpired") {
              vm.$router.push("/" + lowerCaseSlug + "/pwexpired");
            } else if (this.$route.name === "PinRequest") {
              vm.$router.push("/" + lowerCaseSlug + "/pinrequest");
            } else if (this.$route.name === "PwReset") {
              vm.$router.push("/" + lowerCaseSlug + "/pwreset");
            } else {
              vm.$router.push("/" + lowerCaseSlug);
            }
            const obj = this.$h.getTeamObjectBySlug(this.teams, this.$route.params.teamSlug);
            if (obj.team) this.passwordPolicy = obj.team.passwordPolicy.description[this.$i18n.locale];
            this.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
          })
          .catch((err) => {
            console.log(">>>>>>>< ERROR", err);
            if (err.response && !err.response.data.error.custom && err.request && err.request.status === 404) {
              vm.$snotify.error(vm.$t("toasts.teamForm.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
              this.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
            }
            this.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
          });
      }
    },
    login(d) {
      this.$store.commit("GLOBAL_DEFAULT_LOADING_STARTED");
      const vm = this;
      const teamObj = this.$h.getTeamObjectBySlug(this.teams, this.$route.params.teamSlug);
      const data = {
        username: d.email.toLowerCase(),
        password: d.password,
        UserPoolId: teamObj.cognito.pool_id,
        ClientId: teamObj.cognito.client_id,
        mfaSettings: teamObj.cognito.mfa_settings,
      };
      let storageObject = JSON.parse(localStorage.getItem("localStorageEnvivo"));
      if (!storageObject) storageObject = {};
      let rememeberMeObject = JSON.parse(localStorage.getItem("rememberMeEnvivo"));
      if (!rememeberMeObject) rememeberMeObject = {};
      if (d.rememberMe) {
        storageObject[teamObj.team.uid] = "true";
        localStorage.setItem("localStorageEnvivo", JSON.stringify(storageObject));
        sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(storageObject));
        rememeberMeObject[teamObj.team.uid] = "true";
        localStorage.setItem("rememberMeEnvivo", JSON.stringify(rememeberMeObject));
      } else {
        storageObject[teamObj.team.uid] = "false";
        localStorage.setItem("localStorageEnvivo", JSON.stringify(storageObject));
        sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(storageObject));
        rememeberMeObject[teamObj.team.uid] = "false";
        localStorage.setItem("rememberMeEnvivo", JSON.stringify(rememeberMeObject));
      }
      vm.loginAndGetAuthAccount({ auth: { team: teamObj.team.uid }, data })
        .then((account) => {
          vm.$snotify.clear();
          vm.initGlobalTeamSettings(teamObj.team.uid);
          vm.$initLocale(account.locale);
          vm.$eventbus.$emit("setProfileDropdown", teamObj.team.uid);
          vm.$goTo("Dashboard", { team: teamObj.team.uid });
        })
        .catch((err) => {
          vm.$store.commit("GLOBAL_DEFAULT_LOADING_ENDED");
          if (err.response && err.response.status === 401) {
            if (err.response.data.error.code === "GEN-PASSWORD-EXPIRED") {
              vm.$snotify.error(vm.$t("toasts.login.passwordExpired"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            } else {
              if (err.response && !err.response.data.error.custom) {
                vm.$snotify.error(vm.$t("toasts.login.wrongTeam"), vm.$t("toasts.error"), {
                  timeout: 0,
                  icon: vm.$errorIcon,
                });
              }
              vm.removeCognitoSession(teamObj.team.uid);
              vm.$goTo("Login");
            }
          }
          switch (err.code) {
            case "InvalidParameterException":
              vm.$snotify.error(vm.$t("toasts.login.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
              break;
            case "UserNotFoundException":
              vm.$snotify.error(vm.$t("toasts.login.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
              break;
            case "NotAuthorizedException":
              vm.$snotify.error(vm.$t("toasts.login.validation"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
              break;
          }
        });
    },
    changeTeam() {
      this.$router.push("/login");
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      isDefaultLoading: "global_is_default_loading",
    }),
  },
};
</script>
